var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Modal, Flex } from "./..";
import { useTheme } from "../../hooks";
/**
 * Dialogs disable all app functionality when they appear, and remain on screen until confirmed, dismissed, or a required action has been taken.
 *
 * It is purposefully interruptive, so they should be used sparingly.
 *
 * Source: [Material Design](https://material.io/design/components/dialogs.html)
 */
export var Dialog = function (_a) {
    var children = _a.children, _b = _a.isFullScreen, isFullScreen = _b === void 0 ? false : _b, _c = _a.isFullWidth, isFullWidth = _c === void 0 ? false : _c, _d = _a.closeOnEscPress, closeOnEscPress = _d === void 0 ? true : _d, lss = _a.lss, props = __rest(_a, ["children", "isFullScreen", "isFullWidth", "closeOnEscPress", "lss"]);
    var theme = useTheme();
    return (React.createElement(Modal, __assign({ role: "dialog", closeOnEscPress: closeOnEscPress }, props),
        React.createElement(Flex, { lss: __assign({ position: 'relative', flexDirection: 'column', my: 'xxl', mx: 'auto', flex: '0 1 auto', height: isFullScreen ? '100%' : 'auto', maxHeight: isFullScreen
                    ? 'none'
                    : "calc(100% - 2 * " + theme.space.xxl + ")", width: isFullWidth || isFullScreen ? '100%' : 'auto', maxWidth: isFullWidth || isFullScreen ? '100%' : theme.breakpoints.tablet, boxShadow: 'xl', bg: 'white', borderRadius: isFullScreen ? 'none' : 'md' }, lss) }, children)));
};
//# sourceMappingURL=Dialog.js.map